import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import pleshDark from "./theme/pleshDark";
import Vote from "./pages/Vote";
import React from "react";
import {CssBaseline, ThemeProvider} from "@mui/material";
import Home from "./pages/Home";

function App() {
    return (
        <ThemeProvider theme={pleshDark}>
            <CssBaseline/>
            <div className="App">
                <Routes>

                    {/** TODO: Quando si crea il branch di un evento specifico: eliminare la route a <Home/>*/}
                    {/* <Route path='/' element={<Home/>}/> */}

                    {/** TODO: Quando si crea il branch di un evento: Scommentare e sostituire:
                     * - eventOwnerId con l'ID dell'utente proprietario dell'evento (nel caso di Plesh l'id è `plesh`)
                     * - eventId con l'ID dell'evento
                     */}
                    {/*<Route path='/' element={<Navigate to={'/vote/<eventOwnerId>/<eventId>'}/>}/>*/}
                    <Route path='/' element={<Navigate to={'/vote/plesh/HoTwhxakbuQ2zje9FxYB'}/>}/>
                    <Route path='/vote/:eventOwnerId/:id' element={<Vote/>}/>
                </Routes>
            </div>
        </ThemeProvider>
    );
}

export default App;
